import { fetchConToken } from "../../helpers/fetch";
import { handleErrorApi } from "../../helpers/randoms";
import { types } from "../../types/types";
import { startAlerta } from "../ui/alertas";
import { finishSpinner, startSpinner } from "../ui/spinner";

export const agregarTipoReclamoAction = (data) => async (dispatch) => {
    dispatch(startSpinner());
    try {
        const response = await fetchConToken(
            `Reclamos/AltaTipoReclamo/${data}`,
            {},
            "POST"
        );
        const body = await response.json();
        if (response.ok) {
            dispatch({
                type: types.newTipoReclamo,
                payload: {descripcion: data, id: body}
            })
            dispatch(startAlerta(`Tipo de reclamo agregado`,'success','Comando Exitoso'));
            dispatch(finishSpinner());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al agregar tipo de reclamo", "Ha ocurrido un error. Intente nuevamente");
    }
};

export const modificarTipoReclamoAction = (data) => async (dispatch) => {
    dispatch(startSpinner());
    try {
        const response = await fetchConToken(
            `Reclamos/ModificarTipoReclamo`,
            data,
            "PUT"
        );
        const body = await response.json();
        if (response.ok) {
            dispatch({
                type: types.putTipoReclamo,
                payload: data
            })
            dispatch(startAlerta(`Tipo de reclamo modificado`,'success','Comando Exitoso'));
            dispatch(finishSpinner());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al modificar tipo de reclamo", "Ha ocurrido un error. Intente nuevamente");
    }
};

export const eliminarTipoReclamoAction = (data) => async (dispatch) => {
    dispatch(startSpinner());
    try {
        const response = await fetchConToken(
            `Reclamos/BajaTipoReclamo/${data}`,
            {},
            "DELETE"
        );
        const body = await response.json();
        if (response.ok) {
            dispatch({
                type: types.removeTipoReclamo,
                payload: data
            })
            dispatch(startAlerta(`Tipo de reclamo eliminado`,'success','Comando Exitoso'));
            dispatch(finishSpinner());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al eliminar tipo de reclamo", "Ha ocurrido un error. Intente nuevamente");
    }
};

export const agregarOrigenReclamoAction = (data) => async (dispatch) => {
    dispatch(startSpinner());
    try {
        const response = await fetchConToken(
            `Reclamos/AltaOrigenReclamo/${data}`,
            {},
            "POST"
        );
        const body = await response.json();
        if (response.ok) {
            dispatch({
                type: types.newOrigenReclamo,
                payload: {descripcion: data, id: body}
            })
            dispatch(startAlerta(`Origen de reclamo agregado`,'success','Comando Exitoso'));
            dispatch(finishSpinner());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al agregar origen de reclamo", "Ha ocurrido un error. Intente nuevamente");
    }
};

export const modificarOrigenReclamoAction = (data) => async (dispatch) => {
    dispatch(startSpinner());
    try {
        const response = await fetchConToken(
            `Reclamos/ModificarOrigenReclamo`,
            data,
            "PUT"
        );
        const body = await response.json();
        if (response.ok) {
            dispatch({
                type: types.putOrigenReclamo,
                payload: data
            })
            dispatch(startAlerta(`Origen de reclamo modificado`,'success','Comando Exitoso'));
            dispatch(finishSpinner());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al modificar origen de reclamo", "Ha ocurrido un error. Intente nuevamente");
    }
};

export const eliminarOrigenReclamoAction = (data) => async (dispatch) => {
    dispatch(startSpinner());
    try {
        const response = await fetchConToken(
            `Reclamos/BajaOrigenReclamo/${data}`,
            {},
            "DELETE"
        );
        const body = await response.json();
        if (response.ok) {
            dispatch({
                type: types.removeOrigenReclamo,
                payload: data
            })
            dispatch(startAlerta(`Origen de reclamo eliminado`,'success','Comando Exitoso'));
            dispatch(finishSpinner());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al eliminar origen de reclamo", "Ha ocurrido un error. Intente nuevamente");
    }
};

export const agregarCategoriaReclamoAction = (data) => async (dispatch) => {
    dispatch(startSpinner());
    try {
        const response = await fetchConToken(
            `Reclamos/AltaCategoriaReclamo/${data}`,
            {},
            "POST"
        );
        const body = await response.json();
        if (response.ok) {
            dispatch({
                type: types.newCategoriaReclamo,
                payload: {descripcion: data, id: body}
            })
            dispatch(startAlerta(`Categoría de reclamo agregada`,'success','Comando Exitoso'));
            dispatch(finishSpinner());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al agregar categoría de reclamo", "Ha ocurrido un error. Intente nuevamente");
    }
};

export const modificarCategoriaReclamoAction = (data) => async (dispatch) => {
    dispatch(startSpinner());
    try {
        const response = await fetchConToken(
            `Reclamos/ModificarCategoriaReclamo`,
            data,
            "PUT"
        );
        const body = await response.json();
        if (response.ok) {
            dispatch({
                type: types.putCategoriaReclamo,
                payload: data
            })
            dispatch(startAlerta(`Categoria de reclamo modificada`,'success','Comando Exitoso'));
            dispatch(finishSpinner());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al modificar categoria de reclamo", "Ha ocurrido un error. Intente nuevamente");
    }
};

export const eliminarCategoriaReclamoAction = (data) => async (dispatch) => {
    dispatch(startSpinner());
    try {
        const response = await fetchConToken(
            `Reclamos/BajaCategoriaReclamo/${data}`,
            {},
            "DELETE"
        );
        const body = await response.json();
        if (response.ok) {
            dispatch({
                type: types.removeCategoriaReclamo,
                payload: data
            })
            dispatch(startAlerta(`Categoria de reclamo eliminado`,'success','Comando Exitoso'));
            dispatch(finishSpinner());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al eliminar categoria de reclamo", "Ha ocurrido un error. Intente nuevamente");
    }
};